<template>

  <div id="wrapper">
    <div class="normalheader ">
      <div class="hpanel">
        <div class="panel-body">
          <h3 class="font-light m-b-xs" v-if="question">
            {{questionName}} Preview - <router-link class="font-bold text-info" :to="{name: 'ProjectDetails', params: {id: question.project.id}}">{{question.project.name}}</router-link>
          </h3>
          <small></small>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="row">
        <div class="col-xs-12" v-if="question">
          <my-documents :project-id="question.project.id" origin="question_pdf"></my-documents>
        </div>
      </div>

      <div class="row" v-if="question">
        <div class="col-lg-12">
          <div class="hpanel hblue">
            <div class="panel-body info">
              <template v-if="question.status.id === 1">
                <template v-if="$auth.user().id === question.consultant_id">
                  Draft status {{questionName}}. You can modify this {{questionName}} and validate when it's filled
                </template>
                <template v-else>
                  Draft status {{questionName}}. It will be sent to your assigned broker for validation when all mandatory fields are completed.
                </template>
              </template>
              <template v-else-if="question.status.id === 2">
                <template v-if="$auth.user().id === question.consultant_id">
                  {{questionName}} awaiting validation. You may review and validate or not the {{questionName}}. All users sharing this {{questionName}} will be notified.
                </template>
              </template>
              <template v-else-if="question.status.id === 3">
                <template v-if="$auth.user().id === question.consultant_id">
                  This {{questionName}} is reviewing status, you can modify this {{questionName}} and prepare your mailing
                </template>
                <template v-else>
                  This {{questionName}} is reviewing status, the broker can modify this {{questionName}} and prepare a mailing
                </template>
              </template>
              <template v-else-if="question.status.id === 4">
                <template v-if="$auth.user().id === question.consultant_id">
                  This {{questionName}} is publishing status, you can't modify this {{questionName}} but can prepare and send a mailing
                </template>
                <template v-else>
                  This {{questionName}} is publishing status, this {{questionName}} can't be modified
                </template>
              </template>
              <template v-else-if="question.status.id === 5">
                This {{questionName}} was already emailed and cannot be changed for traceability. Duplicate project to revise {{questionName}}.
              </template>

            </div>
          </div>
        </div>

      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="hpanel">
            <div class="panel-heading">
              {{questionName}} Preview
              <span class="label" v-if="question" :class="labelStatus">{{question.status.name}}</span>
              <div class="pull-right text-right">
                <div class="btn-group" v-if="question">
                  <template v-if="question.status_id < 3">
                    <router-link v-if="!$user.isBasic()" class="btn btn-default btn-xs" :to="{name: 'QuestionEdit', params: {project_id: projectId, question_id: questionId}}"> <i class="fa fa-edit"></i> Edit</router-link>
                    <button v-else class="btn btn-default btn-xs" @click="$refs.limitPlan.show('editQuestion')"><i class="fa fa-lock"></i> Edit</button>
                  </template>
                  <vue-ladda v-if="!$user.isBasic()" @click="generatePdf" :loading="submit.loading" :data-style="submit.dataStyle"
                             class="btn btn-default btn-xs"> <i class="fa fa-file-pdf-o"></i> PDF</vue-ladda>
                  <button v-else-if="$user.isBasic()" class="btn btn-default btn-xs" @click="$refs.limitPlan.show('pdfQuestion')"><i class="fa fa-lock"></i> PDF</button>
                </div>
              </div>
            </div>
            <div class="panel-body">
              <div class="row" v-if="question">
                <div class="col-xs-12">
                  <div class="col-md-6 m-b-sm" style="margin-top: 15px;">
                    <label>{{questionName}} Title</label>
                    <div v-html="question.title"></div>
                  </div>
                </div>

                <div class="col-xs-12">
                  <div v-if="question.picture" class="col-md-3">
                    <img :src="$apiUrl + question.picture" style="max-width: 100%"/>
                  </div>
                  <div :class="question.picture !== null ? 'col-md-9' : 'col-md-12'">
                    <div class="m-b-sm">
                      <label>Overview</label>
                      <div>
                        <template v-if="question.company_profile">{{question.company_profile}}</template>
                        <template>{{question.objective}}</template> <br>
                        <template v-if="question.issue">{{question.issue}}</template>
                        <template v-if="question.restraint">{{question.restraint}}</template>
                        <template v-if="question.expert_interest"><br>{{question.expert_interest}}</template>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12">
                    <label>Details</label>
                    <div v-html="question.long_description"></div>
                  </div>

                  <div class="col-xs-12" v-if="question.files.length !== 0">
                    <label>Files</label>
                    <div>
                      <a v-for="(file, key) in question.files" :key="key" :href="$apiUrl + file.filename" target="_blank" class="col-xs-3">{{file.filename.replace(/^.*[\\\/]/, '')}}</a>
                    </div>
                  </div>

                  <div class="col-md-6" style="margin-top: 15px">
                    <div>
                      <label>Maturity level</label>
                      <div v-if="question.trl">{{question.trl.name}}</div>

                    </div>

                    <div style="margin-top: 15px">
                      <label>Timeline</label>
                      <div v-if="question.timeline">{{question.timeline.name}}</div>

                    </div>

                    <div style="margin-top: 15px">
                      <label>Intellectual Property Rights</label>
                      <div v-for="(maturity, key) in question.maturities" :key="key">{{maturity.name}}</div>

                    </div>

                    <div style="margin-top: 15px" v-if="question.project.workflow_id !== 3">
                      <label>Expected proposal</label>
                      <div v-for="(proposalRequest, key) in question.proposal_requests" :key="key" v-html="proposalRequest.label"></div>
                    </div>
                  </div>

                  <div class="col-md-6" style="margin-top: 15px" v-if="question.metrics.length">
                    <label>Measurable performance</label>
                    <table cellpadding="1" cellspacing="1" class="table table-condensed table-striped">
                      <thead>
                      <tr>
                        <th>Criteria</th>
                        <th>Common figure (SoA)</th>
                        <th v-if="question.project.workflow_id ===3">Achievable or achieved</th>
                        <th v-else>Target</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(metric, key) in question.metrics" :key="key">
                        <td>{{metric.name}}</td>
                        <td>{{metric.current}}</td>
                        <td>{{metric.target}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                </div>

              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="row" v-if="question && ($auth.user().id === question.consultant_id || $auth.user().id === question.project.owner_id)">
        <div class="col-lg-12">
          <div class="hpanel">
            <div class="panel-heading">
              Additional information
            </div>
            <div class="panel-body">
              <div class="row" v-if="question">
                <div class="col-md-4" v-if="question.nb_response">
                  <label>Nb response would like</label>
                  <div>{{question.nb_response.name}}</div>
                </div>
                <div class="col-md-4" v-if="question.reward_descr">
                  <label>Pre-set-reward</label>
                  <div>{{question.reward_descr}}</div>
                </div>
                <div class="col-md-4" v-if="question.keywords">
                  <label>Keywords</label>
                  <div>{{question.keywords}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="hpanel">
        <div class="panel-heading">
          Actions
        </div>
        <div class="panel-body text-center" v-if="question">
          <template v-if="$user.isBasic()">
            <div class="col-xs-12">
              <router-link class="btn btn-info " :to="{name: 'ProjectDetails', params: {id: projectId}}"><i class="fa fa-arrow-left"></i> Back to project</router-link>
            </div>
          </template>
          <template v-else>
            <template v-if="question.status.id === 1">
              <div class="col-xs-4 border-right">
                <router-link class="btn btn-info " :to="{name: 'ProjectDetails', params: {id: projectId}}"><i class="fa fa-arrow-left"></i> Back to project</router-link>
              </div>
              <div class="col-xs-4 border-right">
                <button class="btn btn-danger " data-toggle="modal" data-target="#modalDeleteQuestion"><i class="fa fa-trash"></i> Delete {{questionName}}</button>
              </div>
              <div class="col-xs-4 border-right">
                <template v-if="$auth.user().id === question.consultant_id">
                  <button class="btn btn-info " data-toggle="modal" data-target="#modalValidateQuestion"><i class="fa fa-check"></i> Validate {{questionName}}</button>
                </template>
                <template v-else>
                  <button class="btn btn-info " data-toggle="modal" data-target="#modalValidateQuestion"><i class="fa fa-paper-plane"></i> Contact Experts</button>
                  <span class="help-block m-b-none">This part is managed by your assigned broker, who will first review your {{questionName}} and list of experts.</span>
                </template>
              </div>
            </template>
            <template v-else-if="question.status.id === 2">
              <template v-if="$auth.user().id === question.consultant_id">
                <div class="col-xs-4 border-right">
                  <router-link class="btn btn-info " :to="{name: 'ProjectDetails', params: {id: projectId}}"><i class="fa fa-arrow-left"></i> Back to project</router-link>
                </div>
                <div class="col-xs-4 border-right">
                  <button class="btn btn-danger " data-toggle="modal" data-target="#modalInvalidateQuestion"><i class="fa fa-times"></i> Do not validate {{questionName}}</button>
                </div>
                <div class="col-xs-4 border-right">
                  <template>
                    <button class="btn btn-info " data-toggle="modal" data-target="#modalValidateQuestion"><i class="fa fa-check"></i> Validate {{questionName}}</button>
                  </template>
                </div>
              </template>
              <template v-else>
                <div class="col-xs-offset-4 col-xs-4">
                  <router-link class="btn btn-info " :to="{name: 'ProjectDetails', params: {id: projectId}}"><i class="fa fa-arrow-left"></i> Back to project</router-link>
                </div>
              </template>
            </template>
            <template v-else>
              <template v-if="$auth.user().id === question.consultant_id">
                <div class="col-xs-6 border-right">
                  <router-link class="btn btn-info " :to="{name: 'ProjectDetails', params: {id: projectId}}"><i class="fa fa-arrow-left"></i> Back to project</router-link>
                </div>
                <div class="col-xs-6 border-right">
                  <router-link class="btn btn-info " :to="{name: 'MailingReview', params: {project_id: projectId, question_id: questionId}}"><i class="fa fa-eye"></i> Mailing Review</router-link>
                </div>
              </template>
              <template v-else>
                <button class="btn btn-info" @click="$router.go(-1)"><i class="fa fa-arrow-left"></i> Back </button>
              </template>
            </template>
          </template>
        </div>
      </div>

    </div>

    <div v-if="question" class="modal fade hmodal-danger" id="modalDeleteQuestion" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="color-line"></div>
          <div class="modal-header">
            <h4 class="modal-title">Delete {{questionName}}</h4>
          </div>
          <div class="modal-body">
            <h3>Are you sure you want to delete this {{questionName}} : {{question.title}}?</h3>
            <div>
              <span>Deleting a {{questionName}} is irreversible</span>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal" >Cancel</button>
            <vue-ladda type="submit" :loading="submit.loading" class="btn btn-danger" :data-style="submit.dataStyle" v-on:click="deleteQuestion"><i class="fa fa-trash"></i> Delete {{questionName}}</vue-ladda>
          </div>
        </div>
      </div>
    </div>

    <div v-if="question" class="modal fade hmodal-danger" id="modalInvalidateQuestion" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="color-line"></div>
          <div class="modal-header">
            <h4 class="modal-title">Not validated {{questionName}}</h4>
          </div>
          <div class="modal-body">
            <h3>Are you sure you don’t want to validate this {{questionName}} : {{question.title}}?</h3>
            <div>
              <span>All users sharing this {{questionName}} will be notified. The {{questionName}} owner will be able to resend for validation.</span>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal" >Cancel</button>
            <vue-ladda type="submit" :loading="submit.loading" class="btn btn-danger" :data-style="submit.dataStyle" v-on:click="invalidateQuestion"><i class="fa fa-times"></i> Do not validate {{questionName}}</vue-ladda>
          </div>
        </div>
      </div>
    </div>

    <div v-if="question" class="modal fade hmodal-success" id="modalValidateQuestion" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="color-line"></div>
          <div class="modal-header">
            <template v-if="$auth.user().id === question.consultant_id">
              <h4 class="modal-title">{{questionName}} validation</h4>
            </template>
            <template v-else>
              <h4 class="modal-title">Contact Experts</h4>
            </template>
          </div>
          <div class="modal-body">
            <template v-if="$auth.user().id === question.consultant_id">
              <h3>Are you sure you want validate this {{questionName}}: {{question.title}} ?</h3>
            </template>
            <template v-else>
              <h3>Are you sure you want to contact experts now ? You won’t be able to modify the {{questionName}}.</h3>
              <div>
                <span>Only your assigned broker will be able to modify the {{questionName}} before contacting the experts.</span>
              </div>
            </template>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal" >Cancel</button>
            <template v-if="$auth.user().id === question.consultant_id">
              <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle" v-on:click="validateQuestion">Validate</vue-ladda>
            </template>
            <template v-else>
              <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle" v-on:click="validateQuestion">Contact Experts</vue-ladda>
            </template>
          </div>
        </div>
      </div>
    </div>

    <limit-plan ref="limitPlan"></limit-plan>
  </div>

</template>

<script>
import VueLadda from 'vue-ladda'
import LimitPlan from '../../components/LimitPlan'
import MyDocuments from '../../components/documents/MyDocuments'
export default {
  components: {MyDocuments, VueLadda, LimitPlan},
  name: 'QuestionReview',
  props: [],
  data () {
    return {
      questionId: null,
      projectId: null,
      question: null,
      questionName: 'Question',
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      }
    }
  },
  computed: {
    long_description: function () {
      return this.question.long_description.replace(/<br \/>/mg, '<p></p>')
    },
    labelStatus: function () {
      let labelClass = ''
      switch (this.question.status.id) {
        case 1:
          labelClass = 'label-info'
          break
        case 2:
          labelClass = 'label-info'
          break
        case 3:
          labelClass = 'label-info'
          break
        case 4:
          labelClass = 'label-info'
          break
        case 5:
          labelClass = 'label-info'
          break
      }
      return labelClass
    }
  },
  methods: {
    getResources: function () {
      if (this.questionId !== null) {
        this.axios.get('/question/' + this.questionId + '?relations={status,project}')
          .then((response) => {
            this.question = response.data
            if (typeof this.question.project !== 'undefined' && this.question.project.workflow_id === 3) {
              this.questionName = 'Tech offer'
            }
          })
          .catch((error) => {
            if (error.response.status === 403) {
              this.$router.replace({name: 'Error403', params: {'0': ''}})
            }
            if (error.response.status === 404) {
              this.$router.replace({name: 'Error404', params: {'0': ''}})
            }
          })
      }
    },
    deleteQuestion: function (e) {
      e.preventDefault()

      this.submit.loading = true
      this.axios.delete('/question/' + this.questionId)
        .finally(() => {
          this.submit.loading = false
          $('#modalDeleteQuestion').modal('hide')
        })
    },
    validateQuestion: function (e) {
      e.preventDefault()

      this.submit.loading = true
      this.axios.patch('/question/' + this.questionId + '/validation')
        .then((response) => {
          let question = response.data

          $('#modalValidateQuestion').modal('hide')
          if (question.status_id === 2) {
            this.$notify({
              type: 'info',
              title: this.questionName + ' sent for validation',
              content: 'The broker will be notified and will be able to validate or not this ' + this.questionName,
              placement: 'bottom-right'
            })

            this.$router.push({name: 'ProjectDetails', params: { id: this.projectId}})
            this.$salesMachine.requestValidateQuestion({question_id: this.questionId, project_id: this.projectId})
          } else if (question.status_id === 3) {
            this.$notify({
              type: 'info',
              title: this.questionName + ' validated',
              content: 'All users sharing this ' + this.questionName + ' will be notified',
              placement: 'bottom-right'
            })

            this.$router.push({name: 'MailingReview', params: { project_id: this.projectId, question_id: this.question.id}})
            this.$salesMachine.validateQuestion({question_id: this.questionId, project_id: this.projectId})
          }
        })
        .catch((error) => {
          if (error.response.data.status_code === 400) {
            this.$notify({
              type: 'danger',
              title: 'The ' + this.questionName + ' cannot be validated',
              content: 'All mandatory fields (with *) have to be completed',
              placement: 'bottom-right'
            })
          }
        }).finally(() => {
          $('#modalValidateQuestion').modal('hide')
          this.submit.loading = false
        })
    },
    invalidateQuestion: function (e) {
      e.preventDefault()

      this.submit.loading = true
      this.axios.patch('/question/' + this.questionId + '/invalidate')
        .then((response) => {
          this.$notify({
            type: 'info',
            title: 'Not validated ' + this.questionName,
            content: 'The ' + this.questionName + ' owner will be notified and will be able to resend for validation.',
            placement: 'bottom-right'
          })

          $('#modalInvalidateQuestion').modal('hide')
          this.$router.push({name: 'ProjectDetails', params: { id: this.projectId}})
        })
        .finally(() => {
          $('#modalInvalidateQuestion').modal('hide')
          this.submit.loading = false
        })
    },
    generatePdf: function () {
      if (this.questionId !== null) {
        this.submit.loading = true
        this.axios.post('/question/' + this.questionId + '/pdf/').then((response) => {
          this.$notify({
            type: 'success',
            title: 'Document under preparation',
            content: 'The document is being prepared, an email will be sent to you as soon as it is ready. You can check its status in the export menu.',
            placement: 'bottom-right'
          })
        }).catch((error) => {
          this.$notify({
            type: 'danger',
            title: 'an error has occurred',
            content: 'an error occurred while generating the document, please consult our support',
            placement: 'bottom-right'
          })
        }).finally(() => {
          this.submit.loading = false
        })
      }
    }
  },
  beforeMount () {
    this.questionId = this.$route.params.question_id
    this.projectId = this.$route.params.project_id

    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/question/QuestionReview.vue